import { supabase } from './supabase'

const VALID_EVENTS = new Set([
  'search_completed',
  'search_failed',
  'result_selected',
  'search_abandoned',
  'discovery_started',
  'discovery_completed',
  'discovery_queued',
  'discovery_failed',
])

export function createSearchId() {
  return globalThis.crypto?.randomUUID?.()
    || `search-${Date.now()}-${Math.random().toString(16).slice(2)}`
}

// Telemetry is deliberately best-effort. A denied insert or an unapplied
// migration must never turn a successful search into a product failure.
export async function recordSearchTelemetry(event) {
  if (!VALID_EVENTS.has(event?.event_type)) return false
  try {
    const { data: { session } = {} } = await supabase.auth.getSession()
    if (!session?.user?.id) return false
    const { error } = await supabase.from('search_telemetry').insert({
      user_id: session.user.id,
      search_id: event.search_id,
      event_type: event.event_type,
      query: String(event.query || '').trim().slice(0, 120) || null,
      result_count: Number.isInteger(event.result_count) ? event.result_count : null,
      latency_ms: Number.isFinite(event.latency_ms) ? Math.max(0, Math.round(event.latency_ms)) : null,
      match_confidence: Number.isFinite(event.match_confidence) ? event.match_confidence : null,
      fallback_reason: event.fallback_reason || null,
      selected_catalog_id: event.selected_catalog_id || null,
      discovery_candidate_id: event.discovery_candidate_id || null,
      error_code: event.error_code || null,
      metadata: event.metadata || {},
    })
    return !error
  } catch {
    return false
  }
}

